import { Order } from '@shop/models/src/order.js';
// @ts-ignore I don't know wat da fak is wrong -_-
import { IconType } from 'react-icons';
// @ts-ignore
import { FiTruck } from 'react-icons/fi';
// @ts-ignore
import { MdAutorenew, MdCheck, MdCreditCard } from 'react-icons/md';
// @ts-ignore
import { FcCancel } from 'react-icons/fc';
// @ts-ignore
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const shipmentMethods = [
  // {
  //   id: 'PISHTAZ',
  //   title: 'پست پیشتاز',
  //   description: 'ارسال ۲ تا ۴ روز کاری',
  //   price: 60000,
  //   trackingUrl: (code) => `https://tracking.post.ir/?id=${code}`,
  // },
  // {
  //   id: 'EXPRESS',
  //   title: 'پست ویژه',
  //   description: 'ارسال ۲ تا ۴ روز کاری',
  //   price: 80000,
  //   trackingUrl: (code) => `https://tracking.post.ir/?id=${code}`,
  // },
  // {
  //   id: 'TIPAX',
  //   title: 'تیپاکس',
  //   description: 'ارسال ۲ تا ۴ روز کاری',
  //   price: 35000,
  //   trackingUrl: (code) => `https://tipaxco.com/tracking?id=${code}`,
  // },
  {
    id: 'BOXIT',
    title: 'باکسیت',
    description: 'ارسال تا ۵ روز کاری',
    price: 50_000,
    trackingUrl: (code) => `https://public.boxit.ir/tracking?code=${code}`,
  },
] as const;

export type ShipmentMethod = (typeof shipmentMethods)[number];

export const orderStatus: Record<
  Order['status'],
  { description: string; icon: IconType; color: string; emoji: string }
> = {
  PAYMENT: {
    description: 'در انتظار پرداخت',
    icon: MdCreditCard,
    color: 'orange',
    emoji: '',
  },
  PROCESSING: {
    description: 'در حال پردازش',
    icon: AiOutlineLoading3Quarters,
    color: 'purple',
    emoji: '🧮',
  },
  PENDING: {
    description: 'درحال آماده سازی',
    icon: MdAutorenew,
    color: 'deepskyblue',
    emoji: '⏳',
  },
  DELIVERING: {
    description: 'ارسال شد',
    icon: FiTruck,
    color: 'blue',
    emoji: '🚚',
  },
  DELIVERED: {
    description: 'تحویل داده شد',
    icon: MdCheck,
    color: 'green',
    emoji: '✅',
  },
  CANCELED: {
    description: 'لغو شد',
    icon: FcCancel,
    color: 'red',
    emoji: '❌',
  },
};
